
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import LazyImage from "@src/components/LazyImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import {
  ginzaKobikichoKobikichoInImage,
  ginzaKobikichoKobikichoMenuImage,
  ginzaKobikichoKobikichoSobaImage,
} from "@src/constants/images";
export const meta = {
  path: "/media/ginza/kobikicho",
  title: "【整理券必須！？】オープン一年足らずで銀座No1になったラーメンの名店「八五」",
  description: "銀座でオープン一年足らずでトップに上り詰めた話題のラーメン店「銀座 八五」。整理券がないと入れない仕組みや、他のラーメン店とは一線を画す割烹の雰囲気、洗練された食材を最大限引き出したラーメンの味についてご紹介します。ラーメン好きには絶対に外せない「銀座 八五」の魅力について迫ります。",
  topImg: ginzaKobikichoKobikichoSobaImage,
  author: murakamiMasanori,
  tags: ["銀座", "有名店", "そば", "人気店", "お店の紹介", "1人メシ", "食べログ高評価", "ミシュラン掲載"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`銀座ランチの中でも異彩を放つ、秘密が多い「木挽町 湯津上屋」。`}</p>
    <p>{`オープン前から並ばないと 1 時間近く待たないといけないこともある当店は、写真禁止やメニュー表にこだわりがあり、ネット上に中々情報が載っていません。
その木挽町 湯津上屋の秘密を、今回は当店に行った筆者が赤裸々にご紹介しておりますので、是非ご一読ください。`}</p>
    <h2>{`木挽町 湯津上屋とは？`}</h2>
    <InstaImage postId="CB1MwEYgR7Q" mdxType="InstaImage" />
    <p>{`名前なんて読むんだ？という店名からインパクトのある蕎麦のお店。
「こびきちょう　ゆづかみや」と呼び、銀座の蕎麦ランキングの中でも上位にランクインし、蕎麦好きから支持を得ている隠れ名店で、リピーターが多いのが特徴。`}</p>
    <h3>{`銀座の喧騒から離れた場所に`}</h3>
    <p>{`東銀座駅から徒歩 5 分ほど離れたところに位置するお店で、細い路地を入ったところに、まるで古民家のように佇んでいるお店です。
初めての方は外観からは判断しづらいので、見つけるのに苦労するかもしれません。`}</p>
    <h3>{`店内も独特の雰囲気`}</h3>
    <LazyImage img={ginzaKobikichoKobikichoInImage} alt="店内" mdxType="LazyImage" />
    <p>{`狭い入り口を潜ると、ほんの数席しかない小さな店内になっています。
オープンキッチンで店主が料理をしている姿を覗き込むことができており、本当に小さくこじんまりとした、いわば主張の少ないシンプルな店内です。`}</p>
    <h3>{`写真禁止の店内`}</h3>
    <InstaImage postId="B0Z6Qb-go45" mdxType="InstaImage" />
    <p>{`メニューが運ばれてきたときに写真を撮ろうとすると、「写真お断りしております」と店主の方からご指摘を受けました。
こういった独自のスタンスが木挽町 湯津上屋の特徴とも言えると思います。`}</p>
    <hr></hr>
    <h2>{`ランチメニュー`}</h2>
    <p>{`メニューは蕎麦だけではなく、名物の卵焼きからお酒まで、幅広く用意されているのが特徴。
それも目の前で一人の大将がコツコツとメニューのメモも取らず作っているところを見ることができる。`}</p>
    <h3>{`とにかくシンプルを極めたメニュー表`}</h3>
    <p>{`//木挽町メニューの写真を挿入`}</p>
    <LazyImage img={ginzaKobikichoKobikichoMenuImage} alt="メニュー" mdxType="LazyImage" />
    <p>{`和紙のような手触りのメニューに、手書きで記載されたメニュー表は文字が少し読みづらい。
また、写真などもないため、ネットなどにも出回っていないため、想像しながら楽しむしかないというのが木挽町 湯津上屋の特徴です。笑`}</p>
    <h3>{`名物の「せいろ蕎麦」`}</h3>
    <InstaImage postId="BF0Zo26sOCY" mdxType="InstaImage" />
    <p>{`夏の暑い日には相性抜群の蕎麦がこちらのせいろ蕎麦。
一つ一つ丁寧にカットする店主の姿を眺めることもでき、均等に配置された蕎麦はスッキリした味わい。`}</p>
    <p>{`スープも飲み干したくなるような、シンプルだけど奥行きのある味わいです。`}</p>
    <h3>{`ここでしか食べられない「鴨蕎麦」`}</h3>
    <InstaImage postId="ByeMbjQgwZI" mdxType="InstaImage" />
    <p>{`こちらもリピーターから初めての方まで人気となっているメニューです。
赤だしのような濃厚な色をした出汁に、鴨などが入ったそ蕎麦は、ここでしか食べられない独特の風味。`}</p>
    <h3>{`隠れ人気メニューの卵焼き`}</h3>
    <p>{`こちらも店主がゆっくりと卵焼きを作っているところを見ることができます。
値段は少し高いと思うのですが、実際に見るとかなりボリューム感のある量で、甘い味わいがしっかり染み込んでいます。`}</p>
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <InstaImage postId="Bm3SC8YH-Hw" mdxType="InstaImage" />
    <p>{`人気なのはもちろん、席数が少ないこともあり、構造上行列ができやすいのが木挽町 湯津上屋の特徴。
特にオープン前から 10 人前後の待ち人数があり、最初の着席を逃すと 1 時間近く待たないといけない可能性が高いです。`}</p>
    <p>{`どうしても並びたくない方は、オープン前から並ぶことをお勧めします。`}</p>
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`銀座の蕎麦の名店、木挽町 湯津上屋についてご紹介してきましたがいかがでしたか。
ランチで行くにしても人気のお店なのと、店主がマイペースで料理を作るので、かなり待ち時間が長いのには注意をしましょう。`}</p>
    <p>{`味は人気と言われるほどの理由がそこにあるので、是非一度足を亜混んでみてください。`}</p>
    <ShopInfoBox shopId="btf2dui23akg00ddbgng" mdxType="ShopInfoBox" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;